import { Component, OnInit, Inject } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { OKTA_AUTH } from "@okta/okta-angular";
import OktaAuth from "@okta/okta-auth-js";

@Component({
  selector: "app-login",
  standalone: false,
  template: `
    <div class="login-container">
      <div class="login-card">
        <h1>Conversational Agents Dashboard</h1>
        <p>{{ message }}</p>
        @if (isLoading) {
          <mat-spinner diameter="40"></mat-spinner>
        } @else if (!isCallback) {
          <button mat-raised-button color="primary" (click)="login()">
            Sign in with Okta
          </button>
        }
      </div>
    </div>
  `,
  styles: [
    `
      .login-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      }
      .login-card {
        background: white;
        padding: 48px;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
        text-align: center;
        max-width: 400px;
      }
      h1 {
        margin-bottom: 24px;
        color: #333;
      }
      p {
        color: #666;
        margin-bottom: 24px;
      }
      mat-spinner {
        margin: 0 auto;
      }
    `,
  ],
})
export class LoginComponent implements OnInit {
  isLoading = false;
  isCallback = false;
  message = "Please sign in to continue.";

  constructor(
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  async ngOnInit(): Promise<void> {
    // Check if this is a callback from Okta
    if (this.oktaAuth.isLoginRedirect()) {
      this.isCallback = true;
      this.isLoading = true;
      this.message = "Completing sign in...";

      try {
        await this.oktaAuth.handleLoginRedirect();
        const returnUrl =
          this.route.snapshot.queryParams["returnUrl"] || "/dashboard";
        this.router.navigate([returnUrl]);
      } catch (error) {
        console.error("Error handling login redirect:", error);
        this.message = "Sign in failed. Please try again.";
        this.isLoading = false;
        this.isCallback = false;
      }
    } else {
      // Check if already authenticated
      const isAuthenticated = await this.oktaAuth.isAuthenticated();
      if (isAuthenticated) {
        const returnUrl =
          this.route.snapshot.queryParams["returnUrl"] || "/dashboard";
        this.router.navigate([returnUrl]);
      }
    }
  }

  async login(): Promise<void> {
    this.isLoading = true;
    this.message = "Signing in...";

    // TODO: Re-enable Okta auth when configured
    // const returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/dashboard";
    // await this.oktaAuth.signInWithRedirect({ originalUri: returnUrl });

    // Temporary: Fake login for development
    await new Promise((resolve) => setTimeout(resolve, 1000));
    const returnUrl =
      this.route.snapshot.queryParams["returnUrl"] || "/dashboard";
    this.router.navigate([returnUrl]);
  }
}
